import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import api, { API_BASE_URL, fetchData } from "../../api/api";
import Spinner from "../../components/common/Spinner";
import { AuthContext } from "../../context/AuthContext";
import { decryptData, encryptData } from "../../utils/encryptDecrypt";
import { toast } from "react-toastify";
import { CONSTANT_REDIRECT_TIME, getGender } from "../../constant/common";
import MasterAdminLayout from "../../layouts/MasterAdminLayout";
import Select from "react-select";


const MasterAdminLeadsDetails = () => {

    const { leads_id } = useParams();

    const decrypted_leads_id = decryptData(leads_id);

    const didFetch = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const [leadsDetails, setLeadsDetails] = useState([]);

    const [leadsPractices, setLeadsPracticesList] = useState([]);

    const [practicesList, setpracticesList] = useState([]);

    const [selectedPractices, setSelectedPractices] = useState(null);

    const [isDelete, setIsDelete] = useState(false);

    const [isAssign, setIsAssign] = useState(false);

    const [selectedLeads, setSelectedLeads] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);

    const getLeadsDetails = async () => {
        if (decrypted_leads_id) {
            setIsLoading(true);
            try {
                const data = await fetchData('/details-leads', {
                    leads_id: decrypted_leads_id
                });
                setLeadsDetails(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const getLeadsPractices = async () => {
        if (decrypted_leads_id) {
            setIsLoading(true);
            try {
                const data = await fetchData('/get-leads-practices', {
                    fk_leads_id: decrypted_leads_id
                });
                setLeadsPracticesList(data);
                setCurrentPage(1);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const getPractices = async () => {
        try {
            const data = await fetchData('/get-practices-dropdown', {
                status: 1
            });
            setpracticesList(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getLeadsDetails();
            getLeadsPractices();
            getPractices();
            didFetch.current = true;
        }
    }, []);

    const itemsPerPage = 10;

    const totalPages = Math.ceil(leadsPractices.length / itemsPerPage);

    const paginatedData = leadsPractices?.length > 0 ? leadsPractices.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    ) : [];

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleDelete = async () => {

        const payload = {
            practices_leads_id: selectedLeads?.practices_leads_id
        };

        try {
            const response = await api.post("un-assign-leads", payload);

            if (response?.data?.status === true) {
                toast.success(response.data?.message);

                setTimeout(() => {
                    getLeadsPractices();
                }, CONSTANT_REDIRECT_TIME);


            } else {
                toast.error(response?.data?.message || "Failed to delete.");
                return null;
            }
        } catch (error) {
            console.error("Error delete :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }

        setSelectedLeads(null);
        setIsDelete(false);
    }

    const handleAssignLead = async (e) => {
        e.preventDefault();

        if (!selectedPractices) {
            toast.error("Please select practice or practitioner.");
            return;
        }

        const payload = {
            fk_leads_id: decrypted_leads_id,
            fk_practices_id: selectedPractices
        };

        try {
            const response = await api.post("assign-leads", payload);

            if (response?.data?.status === true) {
                toast.success(response.data?.message);

                setSelectedPractices(null);
                setIsAssign(false);

                setTimeout(() => {
                    getLeadsPractices();
                }, CONSTANT_REDIRECT_TIME);


            } else {
                toast.error(response?.data?.message || "Failed.");
                return null;
            }
        } catch (error) {
            console.error("Error :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }

        setSelectedLeads(null);
        setIsDelete(false);
    }

    if (isLoading) {
        return (<Spinner masterAdminLayout={true} />);
    }


    return (
        <>
            <MasterAdminLayout>
                <main>
                    <div className="bg-lightblue p-4 rounded-xl mt-3 mx-2">
                        <div className="grid grid-cols-12 gap-4 md:gap-6">
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Name</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.name}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Email</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.email}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Phone</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.phone}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Service</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.service?.name}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Practice Type</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.practice_type?.name}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Postcode</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.postcode?.postcode}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Suburb Name</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.suburb?.name}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Gender</label>
                                <p className="text-dark font-medium text-base">{getGender(leadsDetails?.looking_gender)}</p>
                            </div>
                            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
                                <label for="" className="text-blue font-semibold text-base">Looking For</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.looking_for}</p>
                            </div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-9">
                                <label for="" className="text-blue font-semibold text-base">Message</label>
                                <p className="text-dark font-medium text-base">{leadsDetails?.message}</p>
                            </div>
                        </div>
                    </div>

                    <div className="px-4 py-4 sm:px-8 sm:py-6 md:px-12 md:py-7 flex justify-between gap-4 items-center">
                        <h1 className="font-semibold text-lg sm:text-2xl">Assigned Practices & Practitioners</h1>
                        <button
                            onClick={() => {
                                setIsAssign(true)
                            }}
                            type="button" className="py-3 px-4 sm:px-8 border-green  border-2 border-solid bg-green text-white rounded-[8px] font-medium sm:font-semibold text-sm sm:text-base leading-none text-center text-nowrap">
                            + Assign Lead
                        </button>
                    </div>

                    {/* <div className="bg-lightblue p-8 mb-3 max-w-[750px] mx-3">
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">First Name</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">Jatin Koshti</span></div>
                        </div>
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">Email</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">admin@webtual.com</span></div>
                        </div>
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">Number</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">9409511111</span></div>
                        </div>
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">Service</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">Physiotherapist</span></div>
                        </div>
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">Postcode</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">Brinkin (0810)</span></div>
                        </div>
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">Looking For</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">My Self</span></div>
                        </div>
                        <div className="grid grid-cols-12 gap-2 mb-3">
                            <div className="col-span-12 sm:col-span-3"><span className="font-semibold text-blue text-base">Payment</span></div>
                            <div className="col-span-12 sm:col-span-4"><span className="font-semibold text-dark text-base">Medicare (Bulk Billing)</span></div>
                        </div>
                    </div> */}


                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-lightblue">
                                <tr>
                                    <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-center w-[180px]">Number</th>
                                    <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[300px]">Name</th>
                                    <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[300px]">Practice or Practitioner</th>
                                    <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[300px]">Email</th>
                                    <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[300px]">Phone</th>
                                    <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[200px]">Action</th>
                                </tr>
                            </thead>
                            <tbody>

                                {paginatedData?.length > 0 ? paginatedData?.map((item, index) => (
                                    <tr
                                        key={index}
                                        className="border-b-2 border-solid border-[#dfdfdf]">
                                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 text-center">
                                            {/* {((currentPage - 1) * itemsPerPage) + index + 1} */}
                                            {leadsPractices?.length - (((currentPage - 1) * itemsPerPage) + index)}

                                        </td>
                                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
                                            {item?.practice_name}
                                        </td>
                                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
                                            {item?.practice_is_practitioner == "0" ? 'Practice' : 'Practitioner'}
                                        </td>
                                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
                                            {item?.practice_email}
                                        </td>
                                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 text-start">
                                            {item?.practice_phone}
                                        </td>
                                        <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <div className="rounded-full shadow-xs bg-blue max-w-[100px] w-full" role="group">
                                                <button
                                                    onClick={() => {
                                                        setIsDelete(true)
                                                        setSelectedLeads(item)
                                                    }}
                                                    type="button" className="py-2 text-sm font-medium bg-transparent rounded-e-full w-full text-center flex items-center justify-center text-white">
                                                    <svg
                                                        width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={6} className="text-center py-2 px-1.5 sm:py-4 sm:px-3 border-y-2 border-solid border-[#dfdfdf]">No Practices & Practitioners Assigned</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>

                    {paginatedData?.length > 0 && (
                        <div className="px-3 py-3">
                            <ul className="flex items-center -space-x-px h-10 text-base justify-end">
                                {/* Previous Button */}
                                <li>
                                    <button
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${currentPage === 1 ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                    >
                                        <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"></path>
                                        </svg>
                                    </button>
                                </li>

                                {/* Dynamic Pagination Logic */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter((page) => {
                                        return (
                                            page === 1 ||
                                            page === totalPages ||
                                            (page >= currentPage - 1 && page <= currentPage + 1)
                                        );
                                    })
                                    .reduce((acc, page, index, arr) => {
                                        if (index > 0 && page !== arr[index - 1] + 1) {
                                            acc.push("...");
                                        }
                                        acc.push(page);
                                        return acc;
                                    }, [])
                                    .map((page, index) => (
                                        <li key={index}>
                                            {page === "..." ? (
                                                <span className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}>...</span>
                                            ) : (
                                                <button
                                                    onClick={() => handlePageChange(page)}
                                                    className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${currentPage === page ? "bg-white text-blue" : "bg-gray-200 text-blue hover:bg-gray-100"}`}
                                                >
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                {/* Next Button */}
                                <li>
                                    <button
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${currentPage === totalPages ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                    >
                                        <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"></path>
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    )}


                    <div id="deletepopup" className={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${isDelete ? 'flex' : 'hidden'}`}>
                        <div className="max-w-[630px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-6 sm:py-10 sm:px-10 lg:px-20 innercard">
                            <div className="max-w-[312px] w-full flex justify-center items-center gap-6 flex-col mx-auto">
                                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M36 66C19.4314 66 6 52.5684 6 36C6 19.4314 19.4314 6 36 6C52.5684 6 66 19.4314 66 36C66 52.5684 52.5684 66 36 66ZM36 60C49.2549 60 60 49.2549 60 36C60 22.7452 49.2549 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2549 22.7452 60 36 60ZM36 31.7574L44.4852 23.2721L48.7278 27.5147L40.2426 36L48.7278 44.4852L44.4852 48.7278L36 40.2426L27.5147 48.7278L23.2721 44.4852L31.7574 36L23.2721 27.5147L27.5147 23.2721L36 31.7574Z" fill="#FF5252" />
                                </svg>
                                <h4 className="text-center font-bold text-xl mg:text-2xl text-blue">Are you sure! <br />you want to Delete?</h4>
                                <div className="flex justify-between gap-3 w-full">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setIsDelete(false)
                                            setSelectedLeads(null)
                                        }}
                                        className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-dark cancelbtn">Cancel</button>
                                    <button
                                        type="button"
                                        onClick={handleDelete}
                                        className="bg-blue text-center text-white text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-blue deletebtn">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        id="assignpopup"
                        className={`fixed z-[999] inset-0 flex items-center justify-center bg-black bg-opacity-50 px-3 ${isAssign ? "flex" : "hidden"}`}
                    >
                        <div className="emailbox bg-white p-9 rounded-lg shadow-lg w-full max-w-[512px] relative max-h-[90vh]">
                            <button className="absolute right-4 top-4"
                                onClick={() => {
                                    setIsAssign(false)
                                    setSelectedPractices(null)
                                }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.41791 0.436139C0.685579 0.168311 1.04857 0.0178675 1.42704 0.0178675C1.80551 0.0178675 2.1685 0.168311 2.43617 0.436139L9.99103 7.99754L17.5459 0.436139C17.6777 0.299682 17.8351 0.190853 18.0092 0.115982C18.1834 0.0411107 18.3708 0.00171073 18.5602 5.3593e-05C18.7497 -0.00158926 18.9377 0.0345535 19.1131 0.106382C19.2886 0.17821 19.4479 0.284296 19.5819 0.418424C19.7159 0.552553 19.822 0.712052 19.8938 0.887623C19.9654 1.06319 20.0015 1.25131 19.9999 1.44099C19.9982 1.63068 19.9588 1.81814 19.884 1.99242C19.8093 2.16671 19.7005 2.32435 19.5642 2.45612L12.0093 10.0175L19.5642 17.5789C19.8242 17.8484 19.9681 18.2092 19.9648 18.5838C19.9616 18.9584 19.8115 19.3167 19.5468 19.5815C19.2821 19.8464 18.9242 19.9967 18.5499 19.9999C18.1757 20.0032 17.8151 19.8592 17.5459 19.5989L9.99103 12.0375L2.43617 19.5989C2.16697 19.8592 1.80643 20.0032 1.43218 19.9999C1.05793 19.9967 0.699938 19.8464 0.435296 19.5815C0.170653 19.3167 0.0205397 18.9584 0.0172997 18.5838C0.0140454 18.2092 0.157906 17.8484 0.41791 17.5789L7.97277 10.0175L0.41791 2.45612C0.150327 2.18824 0 1.82494 0 1.44612C0 1.06732 0.150327 0.704024 0.41791 0.436139Z" fill="black"></path>
                                </svg>
                            </button>
                            <form
                                onSubmit={handleAssignLead}
                                className="space-y-3">
                                <div>
                                    <label className="mb-2 inline-block text-dark font-semibold text-base">Select practice or practitioner</label>
                                    <Select
                                        value={practicesList?.length > 0 && practicesList?.find(option => option.practices_id === selectedPractices) ? {
                                            value: selectedPractices,
                                            label: practicesList.find(option => option.practices_id === selectedPractices)?.practice_name
                                        } : null}
                                        onChange={(selectedOption) => {
                                            setSelectedPractices(selectedOption.value)
                                        }}
                                        options={practicesList?.length > 0 ? practicesList
                                            ?.filter(practice => leadsPractices.length > 0
                                                ? !leadsPractices.some(lead => lead.practices_id === practice.practices_id)
                                                : true
                                            )
                                            ?.map(practice => ({
                                                value: practice.practices_id,
                                                label: practice.practice_name
                                            })) : []}
                                        isSearchable={true}
                                        required
                                        placeholder="Select practice or practitioner"
                                        className="w-full text-black custom-select"
                                    />
                                </div>
                                <button
                                    type="submit" className="py-3 px-3 bg-blue w-full text-white font-semibold text-lg rounded-xl">
                                    Assign
                                </button>
                            </form>
                        </div>
                    </div>
                </main>

            </MasterAdminLayout>
        </>)
}

export default MasterAdminLeadsDetails